const visitExpandBtnStyles = {
    color: 'messenger.500',
    bg: 'transparent',
};

const visitResetBtnStyles = {
    color: 'messenger.600',
    borderColor: 'messenger.200',
    bg: 'messenger.50',
};

const resetButtonStyles = {
    '& .chakra-button__icon': {
        marginInlineEnd: '1px',
    },
};

export { visitExpandBtnStyles, visitResetBtnStyles, resetButtonStyles };
